<script lang="ts">
  import type { TagsData, TypeItem } from '$types';

  export let data: TagsData;
  export let types: TypeItem[];
  export let showImage: boolean = true;
</script>

<div class="tags">
  <span class="type">
    {#each types as type}
      {#if data.type === 'merchant'}
        {#if showImage}
          <img src={type.merchant.image_url} alt="merchant" />
        {/if}
        {type.merchant.name}
      {:else}
        {#if showImage}
          <img src={type.webshop.image_url} alt="webshop" />
        {/if}
        {type.webshop.name}
      {/if}
    {/each}
  </span>
  <span class="category">{data.category.name}</span>
</div>
